
import React from 'react'
import PropTypes from 'prop-types'

import './Link.scss'

const Link = ({ children, className, href, ...other }) => {
  return (
    <a href={other.disabled ? undefined : href} className={className} {...other}>
      {children}
    </a>
  )
}

Link.defaultProps = {
  href: undefined
}

Link.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string
}

export default Link
